import elevateLogo from '../assets/logos/elevate_logo.svg';

export const elevateTheme = () => {
  return {
    color: {
      ant_variables: {
        //used to set ant tokens
        primary_color_light: '#077882',
        secondary_color_light: '#08b4c4',

        primary_color_dark: '#00A0AC',
        secondary_color_dark: '#08b4c4',
      },
    },
    favicon_url: `${process.env.PUBLIC_URL}/favicon-32x32.png`,
    logo_url: elevateLogo,
  };
};

const oralOnlyTheme = () => {
  return {
    color: {
      ant_variables: {
        primary_color_light: '#26ab1aff',
        secondary_color_light: '#abfeb4ff',

        primary_color_dark: '#26ab1aff',
        secondary_color_dark: '#abfeb4ff',
      },
    },
    favicon_url: `${process.env.PUBLIC_URL}/favicon-32x32.png`,
    logo_url: elevateLogo,
  };
};

const getTenantTheme = () => {
  const url = new URL(window.location.href);
  if (url.hostname.includes('elevate')) {
    return elevateTheme();
  } else if (url.hostname.includes('oral')) {
    return oralOnlyTheme();
  } else {
    return elevateTheme();
  }
};

export class ConfigTenant {
  static data = {
    ...getTenantTheme(),
  };
}
